<template>
  <div class="empty-state-wrapper">
    <img :src="imageSrc">
    <h3 v-if="heading">
      {{ heading }}
    </h3>
    <p v-if="subtitle">
      {{ subtitle }}
    </p>
    <add-button
      class="buttons"
      v-if="button"
    />
  </div>
</template>

<script>
import AddButton from '@/components/layouts/partials/AddButton.vue'

export default {
  components: {
    AddButton,
  },
  props: {
    name: {
      type: String,
      default: 'default'
    },
    heading: {
      type: String
    },
    subtitle: {
      type: String
    },
    button: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      imageSrc: require(`@/assets/empty-${this.name}.svg`)
    }
  },
}
</script>

<style lang="sass" scoped>
.empty-state-wrapper
  position: relative
  left: 0
  right: 0
  bottom: 0
  display: flex
  height: 100%
  justify-content: center
  align-items: center
  flex-direction: column
  pointer-events: none
  text-align: center
  img
    max-width: 100%
    margin-bottom: 20px
  h3
    margin-top: 0
    margin-bottom: 10px
  .subtitle
    font-weight: $font-medium
  p
    color: $ink-lighter
    max-width: 550px
    text-align: center
  .buttons
    pointer-events: all
</style>



// WEBPACK FOOTER //
// EmptyState.vue?006591b2